// Shared suggestions for AutoComplete components

export const CUSTOM_LABEL_SUGGESTIONS = [
  { value: "Production", label: "Production" },
  { value: "Development", label: "Development" },
  { value: "Staging", label: "Staging" },
  { value: "Enterprise", label: "Enterprise" },
  { value: "Beta", label: "Beta" },
  { value: "Internal", label: "Internal" },
  { value: "High Priority", label: "High Priority" },
  { value: "Low Priority", label: "Low Priority" },
  { value: "Critical", label: "Critical" },
  { value: "Experimental", label: "Experimental" },
  { value: "Legacy", label: "Legacy" },
  { value: "New", label: "New" },
  { value: "Future State", label: "Future State" },
];

// You can add other shared suggestion arrays here later, e.g., STATUS_SUGGESTIONS
export const STATUS_SUGGESTIONS = [
  { value: "Live", label: "Live" },
  { value: "Testing", label: "Testing" },
  { value: "Paused", label: "Paused" },
  { value: "Deprecated", label: "Deprecated" },
  { value: "RMN", label: "RMN" },
  { value: "Under Review", label: "Under Review" },
  { value: "Pending Approval", label: "Pending Approval" },
  { value: "Maintenance", label: "Maintenance" },
  { value: "Offline", label: "Offline" },
  { value: "Archived", label: "Archived" },
  { value: "Restricted", label: "Restricted" },
  { value: "Backup", label: "Backup" },
];

// Example: Pipeline suggestions (if needed globally)
export const PIPELINE_SUGGESTIONS = [
  { value: "prod_pipeline", label: "Production Pipeline" },
  { value: "staging_pipeline", label: "Staging Pipeline" },
  { value: "main_pipeline", label: "Main Pipeline" },
  { value: "analytics_pipeline", label: "Analytics Pipeline" },
  { value: "marketing_pipeline", label: "Marketing Pipeline" },
  { value: "user_data_pipeline", label: "User Data Pipeline" },
  { value: "event_pipeline", label: "Event Pipeline" },
  { value: "conversion_pipeline", label: "Conversion Pipeline" },
  { value: "ecommerce_pipeline", label: "E-commerce Pipeline" },
  { value: "backup_pipeline", label: "Backup Pipeline" },
  { value: "test_pipeline", label: "Test Pipeline" },
  { value: "dev_pipeline", label: "Development Pipeline" },
];
